import React, { useReducer, useEffect, useContext } from 'react';
import {
	Avatar,
	ClickAwayListener,
	TextField,
	Link,
	Typography
} from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import Axios from 'axios';
import loadingImg from '../../assets/imgs/icons/loading1.gif';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../../utils/pickBkgClass';

const SearchActionTypes = {
	FOCUS_SEARCH_FIELD: 'FOCUS_SEARCH_FIELD',
	BLUR_SEARCH_FIELD: 'BLUR_SEARCH_FIELD',
	SET_SEARCH_TERM: 'SET_SEARCH_TERM',
	REQUEST_COUTN: 'REQUEST_COUNT',
	SET_SERACH_RESULTS: 'SET_SERACH_RESULTS',
	SET_TO_BE_SHOWN: 'SET_TO_BE_SHOWN',
	APPEND_RESULTS_AREA: 'APPEND_RESULTS_AREA',
	REMOVE_RESULTS_AREA: 'REMOVE_RESULTS_AREA'
};

const INITIAL_STATE = {
	searchExpanded: false,
	searchTerm: '',
	searchResults: [],
	toBeShown: 'neither', // neither <= means do not show neither the loading skeleton nor the search results
	// searching <= means searching so show the loading skeleton
	// searched-notfound <= means finished searching and didn't find any matching posts so show not found
	// searched-found <= means finished searching and did find matching posts so show the list of found posts
	requestCount: 0,
	resultsAreaAppended: false
};

const sleep = ms => new Promise(r => setTimeout(r, ms));

const serachReducer = (currState, action) => {
	switch (action.type) {
		case SearchActionTypes.FOCUS_SEARCH_FIELD:
			return {
				...currState,
				searchExpanded: true
			};
		case SearchActionTypes.BLUR_SEARCH_FIELD:
			return {
				...currState,
				searchExpanded: false
			};
		case SearchActionTypes.SET_SEARCH_TERM:
			return {
				...currState,
				searchTerm: action.payload
			};

		case SearchActionTypes.REQUEST_COUTN:
			return {
				...currState,
				requestCount: currState.requestCount + 1
			};

		case SearchActionTypes.SET_SERACH_RESULTS:
			return {
				...currState,
				searchResults: action.payload
			};

		case SearchActionTypes.SET_TO_BE_SHOWN:
			return {
				...currState,
				toBeShown: action.payload
			};

		case SearchActionTypes.APPEND_RESULTS_AREA:
			return {
				...currState,
				resultsAreaAppended: true
			};
		case SearchActionTypes.REMOVE_RESULTS_AREA:
			return {
				...currState,
				resultsAreaAppended: false
			};

		default:
			return currState;
	}
};

// actions
const expandSearch = () => ({
	type: SearchActionTypes.FOCUS_SEARCH_FIELD
});

const shrinkSearch = () => ({
	type: SearchActionTypes.BLUR_SEARCH_FIELD
});

const setSearchTerm = term => {
	return {
		type: SearchActionTypes.SET_SEARCH_TERM,
		payload: term
	};
};

const setSerachResults = result => {
	return {
		type: SearchActionTypes.SET_SERACH_RESULTS,
		payload: result
	};
};

const setToBeShown = toBeShown => {
	return {
		type: SearchActionTypes.SET_TO_BE_SHOWN,
		payload: toBeShown
	};
};

//////////////////////////////////////////////////
const MainSearch = () => {
	const { themeType, themeName } = useContext(MyThemeContext);
	const [searchState, dispatch] = useReducer(serachReducer, INITIAL_STATE);
	const {
		searchExpanded,
		searchTerm,
		requestCount,
		searchResults,
		toBeShown,
		resultsAreaAppended
	} = searchState;

	const handlehChange = event => {
		const value = event.target.value.trim();
		dispatch(setSearchTerm(value));
	};

	// effect for handling userinput change it will only call the
	// fetch use effect if the user stop typing for 500ms
	useEffect(() => {
		const delay = setTimeout(() => {
			if (searchTerm) {
				// console.log(searchTerm);
				dispatch({ type: SearchActionTypes.REQUEST_COUTN });
			}
		}, 500);
		if (!searchTerm) {
			dispatch(setToBeShown('neither'));
			dispatch(setSerachResults([]));
		}
		return () => clearTimeout(delay);
	}, [searchTerm]);

	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		if (requestCount) {
			// run if requestCount at least one or heiger
			const fetchMatchedPosts = async () => {
				try {
					const response = await Axios.post(
						'/search',
						{ searchTerm },
						{
							cancelToken: cancelTokenSource.token
						}
					);
					console.log('fetched matched posts', response);
					dispatch(setToBeShown('searching'));
					await sleep(400);
					if (response.status === 200 && response.data.length > 0) {
						dispatch(setToBeShown('searched-found'));
						dispatch(setSerachResults(response.data));
					} else {
						dispatch(setToBeShown('searched-notfound'));
						dispatch(setSerachResults([]));
					}
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			fetchMatchedPosts();
		}
		return () => {
			cancelTokenSource.cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestCount]);

	const handleClickAway = () => {
		dispatch({ type: SearchActionTypes.REMOVE_RESULTS_AREA });
	};

	const handleOnFocus = () => {
		dispatch(expandSearch());
		dispatch({ type: SearchActionTypes.APPEND_RESULTS_AREA });
	};

	const handleOnBlur = () => {
		dispatch(shrinkSearch());
		// dispatch({ type: SearchActionTypes.REMOVE_RESULTS_AREA });
	};

	const renderResultsPaper = () => {
		if (toBeShown === 'neither') {
			// if (!searchTerm && toBeShown === 'neither') {
			return (
				<div
					className={`resultsPaper ${pickBkgClass(
						themeName,
						'soft'
					)} ${themeType}`}
				>
					<p>Enter Your Search Term!</p>
				</div>
			);
		} else if (searchTerm && toBeShown === 'searching') {
			return (
				<div
					className={`resultsPaper ${pickBkgClass(
						themeName,
						'soft'
					)} ${themeType}`}
				>
					<p className="searchingText">
						<img src={loadingImg} alt="searching..." />
						Searching...
					</p>
				</div>
			);
		} else if (searchTerm && toBeShown === 'searched-notfound') {
			return (
				<div
					className={`resultsPaper ${pickBkgClass(
						themeName,
						'soft'
					)} ${themeType}`}
				>
					<p>Not found</p>
				</div>
			);
		} else if (searchTerm && toBeShown === 'searched-found') {
			return (
				<div
					className={`resultsPaper ${pickBkgClass(
						themeName,
						'soft'
					)} ${themeType}`}
				>
					{searchResults.map(
						({ _id, title, createdDate, author: { username, avatar } }) => {
							return (
								<div className={`foundPost ${themeType}`} key={_id}>
									<Avatar
										src={avatar ? avatar : null}
										component={RouterLink}
										to={`/profile/${username}`}
										onClick={handleClickAway}
									/>

									<Link
										component={RouterLink}
										to={`/post/${_id}`}
										onClick={handleClickAway}
									>
										<Typography
											className="postTitle"
											variant="h6"
											component="p"
										>
											{title}
										</Typography>
									</Link>
									<div className="username">
										<span>By </span>
										<Link
											color="textPrimary"
											component={RouterLink}
											to={`/profile/${username}`}
											onClick={handleClickAway}
										>
											{username}
										</Link>
									</div>
									<div className="date">
										<Typography variant="body2">
											<span> On </span>
											{moment(createdDate).fromNow()}
										</Typography>
									</div>
								</div>
							);
						}
					)}
				</div>
			);
		}
	};

	return (
		<ClickAwayListener onClickAway={handleClickAway}>
			<div className="search_wrapper_paper">
				<div className="searchWrapper">
					<TextField
						className={`inputWrapper ${searchExpanded ? 'expanded' : ''}`}
						type="search"
						placeholder="Search"
						variant="filled"
						onFocus={handleOnFocus}
						onBlur={handleOnBlur}
						onChange={handlehChange}
					/>
					<SearchOutlined className="searchIcon" />
				</div>
				{resultsAreaAppended && renderResultsPaper()}
			</div>
		</ClickAwayListener>
	);
};

export default MainSearch;
